module.exports = __webpack_public_path__ + "media/Outdoor Swing.96cd9463.mp4";